import Swal from "sweetalert2";

// Register sayfasindaki ile ayni 3 checkbox - ilk (ticari ileti) linksiz,
// diger ikisi /kullanicisozlesmesi ve /aydinlatmametni'ne yeni sekmede acilan
// linkler iceriyor.
const CONSENT_HTML = `
  <div style="text-align:left;">
    <div class="form-check mb-3">
      <input class="form-check-input" type="checkbox" id="googleConsentTicariIleti" />
      <label class="form-check-label" for="googleConsentTicariIleti">
        &nbsp;KVKK Kapsamında Ticari ileti almayı kabul ediyorum
      </label>
    </div>
    <div class="form-check mb-3">
      <input class="form-check-input" type="checkbox" id="googleConsentSozlesme" />
      <label class="form-check-label" for="googleConsentSozlesme">
        <a href="/kullanicisozlesmesi" target="_blank" style="text-decoration:underline;">Kullanım Koşulları ve Üyelik Sözleşmesini</a>
        &nbsp;Kabul ediyorum.
      </label>
    </div>
    <div class="form-check">
      <input class="form-check-input" type="checkbox" id="googleConsentKvkk" />
      <label class="form-check-label" for="googleConsentKvkk">
        <a href="/aydinlatmametni" target="_blank" style="text-decoration:underline;">KVKK Aydınlatma Metni ve Açık Rıza Metnini</a>
        &nbsp;Kabul ediyorum.
      </label>
    </div>
  </div>
`;

// Google'in kendi "Google ile Kaydol" butonu tiklanir tiklanmaz iptal
// edilemeyen native bir akis baslatiyor (click_listener ile durdurulamiyor).
// Bu yuzden gercek GoogleLogin butonunu hic DOM'a basmiyoruz; bu fonksiyon
// onaylanana kadar yerine duz bir placeholder buton gosteriyoruz, onay
// alindiktan sonra gercek Google butonu DOM'a eklenip kullaniciya gosteriliyor.
export const confirmGoogleRegisterConsent = async () => {
    const result = await Swal.fire({
        title: "Kayıt Koşulları",
        html: CONSENT_HTML,
        showCancelButton: true,
        cancelButtonText: "Vazgeç",
        confirmButtonText: "Kabul Ediyorum ve Devam Et",
        allowOutsideClick: false,
        preConfirm: () => {
            const ticariIleti = document.getElementById("googleConsentTicariIleti")?.checked;
            const sozlesme = document.getElementById("googleConsentSozlesme")?.checked;
            const kvkk = document.getElementById("googleConsentKvkk")?.checked;
            if (!ticariIleti || !sozlesme || !kvkk) {
                Swal.showValidationMessage("Devam edebilmek için tüm kutuları işaretlemelisiniz.");
                return false;
            }
            return true;
        },
    });
    return !!result.isConfirmed;
};
